const backlink = document.querySelector('.news__backlink');

(() => {
  if (backlink) {
    backlink.addEventListener('click', () => {
      window.history.back();
    });
  }
})();
